import { lazy, Suspense } from "react";
import { Spin } from "antd";
import { Route, Routes } from "react-router-dom";

import { BootstrapBoundary } from "@/app/bootstrap_boundary";
import { LoginPage } from "@/pages/login/login_page";

const AppShell = lazy(async () => ({
  default: (await import("@/app/app_shell")).AppShell,
}));

export function Application() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route
        path="*"
        element={
          <BootstrapBoundary>
            <Suspense fallback={<Spin fullscreen tip="正在进入系统" />}>
              <AppShell />
            </Suspense>
          </BootstrapBoundary>
        }
      />
    </Routes>
  );
}
